import { Box, Card, CardContent, CardHeader, Grid, makeStyles, Theme, Typography } from "@material-ui/core"
import { ProjectDashboardViewModel } from "../../api/project-dashboard"
import TasksPieChart from "./TasksPieChart"
import CompletedTasksBarChart from "./CompletedTasksBarChart"
import OtherTasksBarChart from "./OtherTasksBarChart"
import { COLOR_GRAY } from "../../../constants"
import { useTranslations } from "./useTranslations"

const TasksOverview = ({ projectDashboard }: TasksOverviewProps) => {
  const classes = useStyles()
  const translations = useTranslations({
    totalNumberOfTasks: projectDashboard.totalNumberOfTasks,
    numberOfCompletedTasks: projectDashboard.numberOfCompletedTasks,
    numberOfNotCompletedTasks: projectDashboard.numberOfNotCompletedTasks,
  })

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <Card variant="outlined" className={classes.card}>
          <CardHeader title={<Typography variant="body1">{translations.pieChartCardHeader}</Typography>} />
          <CardContent className={classes.pieChart}>
            <TasksPieChart projectDashboard={projectDashboard} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Card variant="outlined" className={classes.card}>
          <CardContent>
            <Box className={classes.barChartSection}>
              <Typography variant="body1">{translations.completedBarCardHeader}</Typography>
              <CompletedTasksBarChart projectDashboard={projectDashboard} />
            </Box>

            <Box className={classes.barChartSection}>
              <Typography variant="body1">{translations.notCompletedBarCardHeader}</Typography>
              <OtherTasksBarChart projectDashboard={projectDashboard} />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    height: "100%",
  },
  cardHeader: {
    color: COLOR_GRAY,
    fontSize: "1rem",
  },
  pieChart: {
    padding: theme.spacing(0, 2),
  },
  barChartSection: {
    padding: theme.spacing(0, 0, 4, 0),
  },
}))

export default TasksOverview
type TasksOverviewProps = {
  projectDashboard: ProjectDashboardViewModel
}
